import { render, staticRenderFns } from "./CreateOrUpdateLessonPlan.vue?vue&type=template&id=bb1f3932&scoped=true&"
import script from "./CreateOrUpdateLessonPlan.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateLessonPlan.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrUpdateLessonPlan.vue?vue&type=style&index=0&id=bb1f3932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f3932",
  null
  
)

export default component.exports